import React, { useState } from "react";
import {
    PaymentElement,
    LinkAuthenticationElement,
    useStripe,
    useElements
} from "@stripe/react-stripe-js";
import { useSelector } from 'react-redux';

const isBrowser = typeof window !== "undefined";

const CheckoutForm = ({ payNowClose, setMessage, message }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [email, setEmail] = useState('');
    const [cardholderName, setCardholderName] = useState('');
    const user = useSelector((state) => state.setUserDetails.user);
    const paymentAmount = useSelector((state) => state.strpie.paymentAmount)

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: `http://${window.location.host}/stripe/payment`,
                payment_method_data: {
                    billing_details: {
                        name: cardholderName, // Use the cardholder's name from the state
                        email: email,
                    },
                }
            },
        });

        // Handle payment confirmation errors
        if (isBrowser && window?.gtag) {
            window.gtag("event", "buy_Tc", {
                user_id: user?.id,
            });
        }

        if (error) {
            if (error.type === "card_error" || error.type === "validation_error") {
                setMessage("card_error/validation_error", error.message);
            } else {
                setMessage("An unexpected error occurred.");
            }
        }
    };

    const paymentElementOptions = {
        layout: "tabs"
    };

    return (
        <>
            <form id="payment-form" onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="cardholderName" className='cardHolderLable'>Cardholder's Name</label>
                    <input
                        type="text"
                        id="cardholderName"
                        value={cardholderName}
                        onChange={(e) => setCardholderName(e.target.value)}
                        required
                        className="cardHolderInput"
                        placeholder="CardHolder's Name"
                    />
                </div>
                <LinkAuthenticationElement
                    id="link-authentication-element"
                    onChange={(e) => setEmail(e?.target?.value)}
                />
                <PaymentElement id="payment-element" options={paymentElementOptions} />
                {/* Show any error or success messages */}
                <button id="submit" className="paynow">
                    <span id="button-text">
                        Pay Now ({paymentAmount})
                    </span>
                </button>
                {message && <div id="payment-message">{message}</div>}
                <button onClick={payNowClose} className="paynow">Close</button>
            </form>
        </>
    );
};

export default CheckoutForm;